import { buyAction } from "model/actions/utilities/_buy";
import { formatMessage, randomMessage } from "model/message";

const ACTION_TYPE = "BuyWater";
// Water is the cheapest thing on the shelf and the one drunk fastest, so its lot is the largest.
const BULK = 25;

const messageText = ({ cost, gain }) => {
  const gainText = randomMessage([
    "water bought.",
    "water stocks replenished.",
    "water acquired.",
  ]);
  return formatMessage(gainText, { cost, gain });
};

const gainFor = (count) => ({ water: count });

const config = {
  type: ACTION_TYPE,
  resource: "water",
  label: "Buy Water",
  gainFor,
  messageText,
};

const buyWater = buyAction({ ...config, hotkey: "W" });
const buyWaterBulk = buyAction({ ...config, step: BULK });

export { buyWaterBulk, buyWater as default };
